module.exports = __webpack_public_path__ + "mentos-logo-en.png?9b8a64b5560ee16ded700250cd15d735";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentos-logo-en.png
// module id = 138
// module chunks = 0